<!-- Skip to main content link -->
<a href="#main-content" class="skip-link sr-only">Skip to main content</a>

<ion-app>
  @if (showReplacedSessionNotice()) {
  <app-replaced-session-notice />
  } @else {
  <!-- Desktop Layout -->
  @if(!isMobile()) {
  <!-- <div class="desktop-layout" [class.dark-mode]="isDarkMode"> -->
  <!-- Left Sidebar -->


  <!-- Main Content Area -->
  <!-- <main id="main-content" class="main-content" [class.with-cards]="tilesVisible">
      <div class="content-body page" id="content-body">
        <router-outlet></router-outlet>
      </div>
    </main> -->

  <!-- Tiles Panel Toggle Button (shown when panel is hidden) -->

  <!-- </div> -->



  <!-- Slide-out Panels -->

  }
  <!-- Mobile Layout -->




  <ion-split-pane [when]="breakpointService.desktopSplitPaneWhen" contentId="main">
    @if (showAppChrome()) {
    <ion-menu menuId="main-menu" contentId="mainContent" [swipeGesture]="mainMenu.swipeEnabled">
      <app-sidebar></app-sidebar>
    </ion-menu>
    }





    <div
      id="main"
      [class.main-content]="!isMobile() && showAppChrome()"
      [class.with-cards]="tilesVisible()"
    >
      <div
        id="main-content"
        tabindex="-1"
        [class.content-body]="!isMobile() && showAppChrome()"
        [class.page]="!isMobile() && showAppChrome()"
      >
        <ion-router-outlet id="mainContent"></ion-router-outlet>
      </div>
    </div>

  </ion-split-pane>

  @if (!isMobile() && showAppChrome()) {

  <div class="tiles-panel-toggle" id="tiles-panel-toggle" [style.display]="tilesVisible() ? 'none' : 'block'">
    <button class="tiles-panel-toggle-btn" (click)="showTilesPanel()" title="Show Tiles Panel">
      <fa-icon [icon]="['far', 'chevron-left']" />
    </button>
  </div>

  <div class="tiles-panel-toggle" id="tiles-panel-close-toggle" [style.display]="tilesVisible() ? 'block' : 'none'">
    <button class="tiles-panel-toggle-btn" (click)="hideTilesPanel()" title="Hide Tiles Panel">
      <fa-icon [icon]="['far', 'chevron-right']" />
    </button>
  </div>


  <div class="panel-backdrop" [class.active]="panelHost.isAnyPanelOpen()" (click)="panelHost.dismiss()">
  </div>

  <!-- Right Card Grid -->
  <app-tiles-grid [class.visible]="tilesVisible()" [class.hidden]="!tilesVisible()"></app-tiles-grid>

  <app-slide-out-panel panelName="chatter" [headerTitle]="panelTitles().chatter" [headerIcon]="['far', 'comments']" direction="left">
    <app-chatter-panel></app-chatter-panel>
  </app-slide-out-panel>

  <app-slide-out-panel panelName="trip-qr" [headerTitle]="panelTitles().tripQr" [headerIcon]="['far', 'qrcode']" direction="left">
    <app-trip-qr-panel></app-trip-qr-panel>
  </app-slide-out-panel>

  <app-slide-out-panel panelName="squawks" [headerTitle]="panelTitles().squawks" [headerIcon]="['far', 'bullhorn']" direction="left">
    <app-squawks-panel></app-squawks-panel>
  </app-slide-out-panel>

  <app-slide-out-panel panelName="payment" [headerTitle]="panelTitles().payment" [headerIcon]="['far', 'credit-card']"
    direction="right">
    <app-payment-panel></app-payment-panel>
  </app-slide-out-panel>

  <app-slide-out-panel
    panelName="money-out-payment"
    [headerTitle]="panelTitles().moneyOutPayment"
    [headerIcon]="['far', 'credit-card']"
    direction="right"
  >
    <app-money-out-payment-panel></app-money-out-payment-panel>
  </app-slide-out-panel>

  <app-slide-out-panel
    panelName="payment-importance"
    [headerTitle]="panelTitles().paymentImportance"
    [headerIcon]="['far', 'circle-info']"
    direction="right"
  >
    <app-payment-importance-panel></app-payment-importance-panel>
  </app-slide-out-panel>

  <app-slide-out-panel panelName="profile" [headerTitle]="panelTitles().profile" [headerIcon]="['far', 'user-pen']"
    direction="left">
    <app-profile-panel></app-profile-panel>
  </app-slide-out-panel>

  <app-slide-out-panel
    panelName="change-password"
    [headerTitle]="panelTitles().changePassword"
    [headerIcon]="['far', 'lock']"
    direction="left"
  >
    <app-change-password-panel></app-change-password-panel>
  </app-slide-out-panel>

  <app-slide-out-panel
    panelName="change-email"
    [headerTitle]="panelTitles().changeEmail"
    [headerIcon]="['far', 'at']"
    direction="left"
  >
    <app-change-email-panel></app-change-email-panel>
  </app-slide-out-panel>

  <app-slide-out-panel panelName="location-swap" [headerTitle]="panelTitles().locationSwap" [headerIcon]="['far', 'right-left']"
    direction="left">
    <app-location-swap-panel></app-location-swap-panel>
  </app-slide-out-panel>

  <app-slide-out-panel panelName="budget" [headerTitle]="panelTitles().budget" [headerIcon]="['far', 'money-bill']" direction="right">
    <app-budget-panel></app-budget-panel>
  </app-slide-out-panel>

  <app-slide-out-panel panelName="add-participant" [headerTitle]="panelTitles().addParticipant" [headerIcon]="['far', 'user-plus']" direction="right">
    <app-add-participant></app-add-participant>
  </app-slide-out-panel>

  <app-slide-out-panel panelName="past-participants" [headerTitle]="panelTitles().pastParticipants" [headerIcon]="['far', 'users']" direction="right">
    <app-past-participants></app-past-participants>
  </app-slide-out-panel>

  <app-slide-out-panel panelName="participant-import" [headerTitle]="panelTitles().participantImport" [headerIcon]="['far', 'upload']" direction="right">
    <app-participant-import></app-participant-import>
  </app-slide-out-panel>

  <app-slide-out-panel panelName="interested-parties" [headerTitle]="panelTitles().interestedParties" [headerIcon]="['far', 'users']" direction="right">
    <app-interested-parties></app-interested-parties>
  </app-slide-out-panel>

  <app-slide-out-panel panelName="add-non-roster-user" [headerTitle]="panelTitles().addNonRosterUser" [headerIcon]="['far', 'user-plus']" direction="right">
    <app-add-non-roster-user></app-add-non-roster-user>
  </app-slide-out-panel>

  <app-slide-out-panel panelName="password-reset" [headerTitle]="panelTitles().passwordReset" [headerIcon]="['fas', 'asterisk']" direction="right">
    <app-password-reset></app-password-reset>
  </app-slide-out-panel>

  <app-slide-out-panel panelName="trip-invitation" [headerTitle]="panelTitles().tripInvitation" [headerIcon]="['far', 'paper-plane']" direction="right">
    <app-trip-invitation></app-trip-invitation>
  </app-slide-out-panel>

  <app-slide-out-panel panelName="send-message" [headerTitle]="panelTitles().sendMessage" [headerIcon]="['far', 'envelope']" direction="right">
    <app-send-message></app-send-message>
  </app-slide-out-panel>

  <app-slide-out-panel panelName="edit-info" [headerTitle]="panelTitles().editInfo" [headerIcon]="['far', 'pen-to-square']" direction="right">
    <app-edit-info></app-edit-info>
  </app-slide-out-panel>

  <app-slide-out-panel panelName="remove-from-trip" [headerTitle]="panelTitles().removeFromTrip" [headerIcon]="['far', 'trash']" direction="right">
    <app-remove-from-trip></app-remove-from-trip>
  </app-slide-out-panel>

  <app-slide-out-panel panelName="background-check" [headerTitle]="panelTitles().backgroundCheck" [headerIcon]="['far', 'shield-check']" direction="right">
    <app-participant-background-check-panel></app-participant-background-check-panel>
  </app-slide-out-panel>

  <app-slide-out-panel panelName="promote-gl" [headerTitle]="panelTitles().promoteGl" [headerIcon]="['far', 'right-left']" direction="right">
    <app-promote-gl></app-promote-gl>
  </app-slide-out-panel>

  <app-slide-out-panel
    panelName="change-group-size"
    [headerTitle]="panelHost.changeGroupSizeHeaderTitle()"
    [headerIcon]="['far', 'users']"
    direction="right"
  >
    <app-change-group-size></app-change-group-size>
  </app-slide-out-panel>

  <app-slide-out-panel
    panelName="edit-participant-payment"
    [headerTitle]="panelHost.tripFinancePanelHeaderTitle()"
    [headerIcon]="['far', 'calendar']"
    direction="right"
  >
    <app-edit-participant-payment-panel></app-edit-participant-payment-panel>
  </app-slide-out-panel>

  <app-slide-out-panel
    panelName="edit-online-donation"
    [headerTitle]="panelHost.tripFinancePanelHeaderTitle()"
    [headerIcon]="['far', 'hand-holding-dollar']"
    direction="right"
  >
    <app-edit-online-donation-panel></app-edit-online-donation-panel>
  </app-slide-out-panel>

  <app-slide-out-panel
    panelName="edit-gl-donation"
    [headerTitle]="panelHost.tripFinancePanelHeaderTitle()"
    [headerIcon]="['far', 'dollar']"
    direction="right"
  >
    <app-edit-gl-donation-panel></app-edit-gl-donation-panel>
  </app-slide-out-panel>

  <app-slide-out-panel
    panelName="edit-fundraiser"
    [headerTitle]="panelHost.tripFinancePanelHeaderTitle()"
    [headerIcon]="['far', 'calendar-star']"
    direction="right"
  >
    <app-edit-fundraiser-panel></app-edit-fundraiser-panel>
  </app-slide-out-panel>

  <app-slide-out-panel
    panelName="edit-budget-item"
    [headerTitle]="panelHost.tripFinancePanelHeaderTitle()"
    [headerIcon]="['far', 'money-bill']"
    direction="right"
  >
    <app-edit-budget-item-panel></app-edit-budget-item-panel>
  </app-slide-out-panel>

  <app-slide-out-panel
    panelName="money-in-settings"
    [headerTitle]="panelTitles().moneyInSettings"
    [headerIcon]="['far', 'hand-holding-dollar']"
    direction="right"
  >
    <app-money-in-settings-panel></app-money-in-settings-panel>
  </app-slide-out-panel>

  <app-slide-out-panel
    panelName="fundraising-faq"
    [headerTitle]="panelTitles().fundraisingFaq"
    [headerIcon]="['far', 'question-circle']"
    direction="right"
  >
    <app-fundraising-faq-panel></app-fundraising-faq-panel>
  </app-slide-out-panel>

  <app-slide-out-panel
    panelName="fundraising-profile"
    [headerTitle]="panelHost.fundraisingProfilePanelHeaderTitle()"
    [headerIcon]="['far', 'user']"
    direction="right"
  >
    <app-fundraising-profile-panel></app-fundraising-profile-panel>
  </app-slide-out-panel>

  <app-slide-out-panel
    panelName="edit-flight"
    [headerTitle]="panelHost.flightPanelHeaderTitle()"
    [headerIcon]="['far', 'plane']"
    direction="right"
  >
    <app-edit-flight-panel></app-edit-flight-panel>
  </app-slide-out-panel>

  <app-slide-out-panel
    panelName="delete-flight"
    [headerTitle]="panelTitles().deleteFlight"
    [headerIcon]="['far', 'trash']"
    direction="right"
  >
    <app-delete-flight-panel></app-delete-flight-panel>
  </app-slide-out-panel>

  <app-slide-out-panel
    panelName="edit-trip-event"
    [headerTitle]="panelHost.tripEventPanelHeaderTitle()"
    [headerIcon]="['far', 'calendar']"
    direction="right"
  >
    <app-edit-trip-event-panel></app-edit-trip-event-panel>
  </app-slide-out-panel>

  <app-slide-out-panel
    panelName="upload-team-document"
    [headerTitle]="panelTitles().uploadTeamDocument"
    [headerIcon]="['far', 'upload']"
    direction="right"
  >
    <app-upload-team-document-panel></app-upload-team-document-panel>
  </app-slide-out-panel>

  <app-slide-out-panel
    panelName="request-travel-quote"
    [headerTitle]="panelTitles().requestTravelQuote"
    [headerIcon]="['far', 'plane']"
    direction="right"
  >
    <app-request-travel-quote-panel></app-request-travel-quote-panel>
  </app-slide-out-panel>
  }




  <!-- Panel Backdrop -->

  <app-support-chat-launcher />
  }

</ion-app>